import React from 'react';

/**
 * AlertMessage
 *
 * Shared live-region wrapper for status/error/notification surfaces
 * (Error, AuthError, NotificationBanner, ScreenWrapper error state).
 *
 * Renders its children inside an ARIA "alert" live region so that when the
 * message appears (or its content changes), assistive technology announces
 * it immediately and assertively, without requiring the user to have focus
 * on the region.
 *
 * Consolidates the role/aria-live wiring in one place per design.md
 * Decision 3, rather than repeating role="alert" aria-live="assertive"
 * aria-atomic="true" ad hoc on every status/error surface.
 */
const AlertMessage = ({ children, className, as: Component = 'div', ...rest }) => {
    return (
        <Component
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
            className={className}
            {...rest}
        >
            {children}
        </Component>
    );
};

export default AlertMessage;
